/*
 * --------------------------------------
 * Copyright (c) 2019 BetterCapital.US
 * --------------------------------------
 */
import React, { PureComponent, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import queryString from "query-string";
import { Link } from "react-router-dom";

import { Formik, Field } from "formik";
import * as Yup from "yup";
import Alert from "../../shared/components/Alert";

import EyeIcon from "mdi-react/EyeIcon";
import FormField from "../../shared/components/form/FormField";
import { resetpassword } from "../../actions/auth/authAction";
import logo from "../../images/logo.png";

const initialValues = { password: "", cpassword: "" };
const validationSchema = Yup.object({
  password: Yup.string("")
    .min(8, "Password must contain at least 8 characters")
    .required("Enter your password"),
  cpassword: Yup.string()
    .oneOf([Yup.ref("password")], "Passwords do not match")
    .required("Confirm your required")
});

class ResetPassword extends PureComponent {
  state = {
    loading: false,
    success: null,
    error: null,
    showPassword: false,
    showConfirm: false
  };
  // resetForm;

  showPassword = e => {
    e.preventDefault();
    this.setState({
      showPassword: !this.state.showPassword
    });
  };

  showConfirm = e => {
    e.preventDefault();
    this.setState({
      showConfirm: !this.state.showConfirm
    });
  };

  handleSubmit = values => {
    const queryParams = queryString.parse(this.props.location.search);
    this.setState({ loading: true, error: null, success: null });
    this.props.resetpassword({
      password: values.password,
      email: queryParams.email,
      activation: queryParams.activation
    });
  };

  componentDidMount() {
    if (this.props.auth.isAuthenticated) this.props.history.push("/");
  }

  componentWillReceiveProps(nextProps) {
    const { passProp } = nextProps;

    if (this.state.loading) {
      if (passProp.resetPassSucc === true) {
        this.setState({
          loading: false,
          success: "Password has been resetted successfully"
        });
        return setTimeout(() => this.props.history.push("/login"), 2000);
      } else if (passProp.resetPassSucc === false)
        this.setState({ loading: false, error: passProp.message });
    }
  }

  render() {
    let alertContent;
    const { error, success, loading, showConfirm, showPassword } = this.state;
    if (error) {
      alertContent = (
        <Alert color="danger" className="alert--bordered">
          <p>{error}</p>
        </Alert>
      );
    } else if (success) {
      alertContent = (
        <Alert color="success" className="alert--bordered">
          <p>{success}</p>
        </Alert>
      );
    }

    return (
      <div className="account">
        <div className="account__wrapper">
          <div className="account__card">
            <div className="account__head">
              <img src={logo} alt="BetterCapital.US" />
            </div>
            <h3 style={{ textAlign: "center" }}>Set new password</h3>
            {alertContent}
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={this.handleSubmit}
              render={props => {
                const { handleSubmit /* resetForm */ } = props;
                // this.resetForm = resetForm;
                return (
                  <Fragment>
                    <form className="form" onSubmit={handleSubmit}>
                      <div className="form__form-group form__form-group--forgot">
                        <span className="form__form-group-label">Password</span>
                        <div className="form__form-group-field">
                          <Field
                            name="password"
                            component={FormField}
                            type={showPassword ? "text" : "password"}
                            placeholder="Password"
                          />
                          <button
                            className={`form__form-group-button${
                              showPassword ? " active" : ""
                            }`}
                            onClick={e => this.showPassword(e)}
                          >
                            <EyeIcon />
                          </button>
                        </div>
                      </div>

                      {/* New password */}
                      <div className="form__form-group form__form-group--forgot">
                        <span className="form__form-group-label">
                          Confirm Password
                        </span>
                        <div className="form__form-group-field">
                          <Field
                            name="cpassword"
                            component={FormField}
                            type={showConfirm ? "text" : "password"}
                            placeholder="Confirm password"
                          />
                          <button
                            className={`form__form-group-button${
                              showConfirm ? " active" : ""
                            }`}
                            onClick={e => this.showConfirm(e)}
                          >
                            <EyeIcon />
                          </button>
                        </div>
                      </div>

                      <div className="account__btns">
                        <button
                          className="btn btn-primary account__btn"
                          disabled={loading}
                          type="submit"
                        >
                          {loading ? "Please wait..." : "Reset"}
                        </button>
                      </div>
                    </form>

                    <div className="account__have-account">
                      <p>
                        Go <Link to="/">Home</Link>
                      </p>
                    </div>
                  </Fragment>
                );
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.login,
  passProp: state.pass
});
const mapDispatchToProps = dispatch => ({
  resetpassword: userData => resetpassword(userData, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ResetPassword));
